module.exports = __webpack_public_path__ + "img/p-single-11.ddf96009.jpg";